import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  ProdutoCadastroDto,
  ProdutoCadastroProps,
  ProdutoCadastroSchema,
} from "./ProdutoCadastro.Dto";
import {
  ProdutoAtualizar,
  ProdutoBuscarPorId,
  ProdutoIncluir,
} from "src/services/Estoque.Service";
import {
  criarMenuItem,
  filtrarRotasPorRotaAtual,
  FormatarPontoVirgula,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import { MenuItemDto } from "src/pages/Privada/Menu/MenuItem.Dto";
import { showToast } from "src/componentes";

const ProdutoCadastroCode = (props: ProdutoCadastroProps = {}) => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const dupId = searchParams.get("dupid");
  const [menuItens, setMenuItens] = useState<MenuItemDto[]>([]);
  const location = useLocation();
  const isDuplicate = dupId && true;

  const form = useForm<ProdutoCadastroDto>({
    resolver: yupResolver(ProdutoCadastroSchema),
    defaultValues: (props.initialValue as any) ?? {},
  });

  useEffect(() => {
    const controller = new AbortController();

    const carregarProduto = async (id: string) => {
      const response = await ProdutoBuscarPorId(id);
      if (response.data.success) {
        const data = response.data.data as ProdutoCadastroDto;
        data.valorUnitarioComercial = FormatarPontoVirgula(
          data.valorUnitarioComercial,
        );
        form.reset(data);
      } else {
        showToast({
          message: "Ocorreu erro ao carregar produto",
          title: "Erro",
          variant: "Danger",
        });
      }
    };

    const carregarRotas = () => {
      const rotas = filtrarRotasPorRotaAtual(location.pathname);
      rotas.push(
        criarMenuItem("Duplicar", `/estoque/produtos/cadastro?dupid=${id}`),
      );
      setMenuItens(rotas);
    };

    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          await carregarProduto(id);
          setIncluir(false);
          carregarRotas();
        } else if (dupId) {
          setLoading(true);
          await carregarProduto(dupId);
          setIncluir(true);
        } else {
          if (props.initialValue?.id) {
            setIncluir(false);
          } else {
            setIncluir(true);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id, dupId, location.pathname, form.reset]);

  const onSubmit = async (data: ProdutoCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    if (incluir === true) {
      ProdutoIncluir(data)
        .then((response) => {
          if (response.data.success) {
            if (props.onSuccess) {
              props.onSuccess(response.data.data);
              return;
            }
            navigate("/estoque/produtos");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError,
            );
            showToast({
              message: "Ocorreu erro ao incluir cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id || form.getValues("id"));
      ProdutoAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            if (props.onSuccess) {
              props.onSuccess(response.data.data);
              return;
            }
            navigate("/estoque/produtos");
          } else {
            MapearErrosServidorCampo(
              response.data.notifications,
              form.setError,
            );
            showToast({
              message: "Ocorreu erro ao atualizar cadastro",
              title: "Erro",
              variant: "Danger",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  return {
    loading,
    onSubmit,
    form,
    menuItens,
    handleClickNavigate,
    isDuplicate,
  };
};

export default ProdutoCadastroCode;
